function _refreshDocumentTitle(newVal) {
    document.title = (newVal || '');
}

function makeDocumentTitle(page, subpage) {
    if (page && subpage) {
        return `Word Box — ${page}: ${subpage}`
    }
    if (page) {
        return `Word Box — ${page}`
    }
    return `Word Box`
}

function updateTitle() {
    try {
        _refreshDocumentTitle(window.router.currentRoute.matched.last().instances.default.documentTitle);
    } catch {
        //_refreshDocumentTitle(makeDocumentTitle())
    }
}

export default {
    methods: {
        makeDocumentTitle,
        refreshDocumentTitle(newVal) {
            if (this.$router.currentRoute.matched.last().instances.default === this) {
                _refreshDocumentTitle(newVal);
            }
        }
    },
    computed: {
        /*documentTitle() {
            return this.makeDocumentTitle();
        }*/
    },
    watch: {
        documentTitle(newVal) {
            this.refreshDocumentTitle(newVal);
        }
    },
    mounted() {
        this.refreshDocumentTitle(this.documentTitle);
    },
};
export { updateTitle };

/*$(document).ready(function() {
    window.router.afterEach(updateTitle);
})*/
